import { Injectable } from '@angular/core';
import { Box3 } from 'three';
import { ContainerService } from '../container.service';
import { ArticleContainerUtils } from './article-container-utils';
import { UnitConverter } from '../../common/util/unit-converter';
import { ArticleTypeIds } from '@article/constants/article-type-ids';

export type ProjectDimensionsInMM = {
  width: number;
  height: number;
  depth: number;
}

@Injectable({providedIn: 'root'})
export class GlobalArticleContainerUtils {

  constructor(private containerService: ContainerService) {
  }

  public calculateBBoxForAllArticlesInGlobal(): Box3 {
    const articles = this.containerService.enumerateArticleContainersInGlobal();
    return ArticleContainerUtils.calculateBBoxForArticles(articles);
  }

  public calculateProjectDimensionsInMM(): ProjectDimensionsInMM {
    const articles =
      this.containerService.enumerateArticleContainersInGlobal()
        .filter(container => container.article.type.id !== ArticleTypeIds.DRILLING_HOLE);
    const bbox = ArticleContainerUtils.calculateBBoxForArticles(articles);
    return {
      width: UnitConverter.fromTo('3d', 'mm', bbox.max.x - bbox.min.x),
      height: UnitConverter.fromTo('3d', 'mm', bbox.max.y - bbox.min.y),
      depth: UnitConverter.fromTo('3d', 'mm', bbox.max.z - bbox.min.z),
    };
  }
}
